import { useCallback, useEffect, useRef } from 'react';

const AUTOFILL_SYNC_DELAYS = [0, 100, 250, 500, 1000, 1500];

export const useAutofillSync = (
  sync: () => void,
  triggerKey?: unknown
) => {
  const syncRef = useRef(sync);
  const timeoutIdsRef = useRef<number[]>([]);

  useEffect(() => {
    syncRef.current = sync;
  }, [sync]);

  const clearScheduledSyncs = useCallback(() => {
    timeoutIdsRef.current.forEach((timeoutId) => {
      window.clearTimeout(timeoutId);
    });
    timeoutIdsRef.current = [];
  }, []);

  const scheduleAutofillSync = useCallback(() => {
    clearScheduledSyncs();

    AUTOFILL_SYNC_DELAYS.forEach((delay) => {
      const timeoutId = window.setTimeout(() => {
        syncRef.current();
      }, delay);

      timeoutIdsRef.current.push(timeoutId);
    });
  }, [clearScheduledSyncs]);

  useEffect(() => {
    scheduleAutofillSync();
    return clearScheduledSyncs;
  }, [scheduleAutofillSync, clearScheduledSyncs, triggerKey]);

  return scheduleAutofillSync;
};
